import { useEffect, useRef } from 'react';

export function useScrollIntoViewOnMountRef<T extends HTMLElement>(node: T | null, applyScrollIntoViewOnMount = true) {
  const ref = useRef(node);
  useEffect(() => {
    if (applyScrollIntoViewOnMount) {
      if (ref.current) {
        ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [applyScrollIntoViewOnMount]);
  return ref;
}
